import React, {Component} from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {Form} from 'formsy-react'
import moment from 'moment'
import styled from 'styled-components'
import {Button, DatePicker, Select} from 'advenio-components'
import MedalliaActions from '../../Data/Redux/MedalliaRedux'
import {ReportHeader, ReportContainer} from '../../Components/ReportsComponents'

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: ${props => props.large ? 'row' : 'column'};
  padding: 16px;
  width: ${props => props.large ? '648px' : '400px'};
`

const Row = styled.div`
  width: 100%;
  ${({takeHeight}) => !takeHeight && 'height: 115px;'}
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  margin-right: 10px;
  flex-direction: ${({column}) => column && 'column'};
`

class Medallia extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      start_date: null,
      end_date: null,
      type_quiz:null,
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  onChange = (model) => {
    this.setState({start_date: model.start_date, end_date: model.end_date, type_quiz: model.type_quiz})
  }

  updateWindowDimensions = () => {
    this.setState({width: window.innerWidth})
  }

  download = () => {
    const {start_date, end_date, type_quiz } = this.state

    if (start_date === null || end_date === null || type_quiz === null) {
      return false
    }


    this.props.getMedalliaExcel(start_date, end_date, type_quiz)

  }

  render() {
    const {width} = this.state
    return (
      <ReportContainer>
        <ReportHeader>
          <span>Reporte de medallia</span>
        </ReportHeader>
        <Form
          onChange={this.onChange}
        >
          <Container large={width > 768}>
            <Row>
              <DatePicker
                name="start_date"
                label="Fecha inicio"
                // style={{ marginRight: '5px' }}
                // value={moment().subtract(1, 'months').format('YYYY-MM-DD')}
              />
            </Row>
            <Row>
              <DatePicker
                name="end_date"
                label="Fecha Fin"
                // value={moment().format('YYYY-MM-DD')}
              />
            </Row>
            <Row>
              <Select
                emptyElement
                label="Tipo de Encuesta"
                name="type_quiz"
                options={[
                  {id: 1, label: "Inscripción Y Reinscripción", value:1},
                  {id: 2, label: "Experiencia de instalaciones", value:2},
                  {id: 3,  label: "Experiencia de servicios", value: 3},
                  {id: 4, label: "Deserción", value: 4},
                  {id: 5, label: "Egreso", value: 5},
                ]}
              />
            </Row>
            <Row takeHeight column >
            <Button marginRight="0" marginLeft="0" danger small onClick={this.download} loading={this.props.medalliaLoading}>
              Descargar
            </Button>
            </Row>
          </Container>
        </Form>
      </ReportContainer>
    )
  }
}


const mapStateToProps = (state) => ({
  medalliaLoading:  state.medallia.sending.fetching
})

const mapDispatchToProps = dispatch => ({
  getMedalliaExcel: (start_date, end_date, type_quiz) =>
    dispatch(MedalliaActions.MedalliaRequest(start_date, end_date, type_quiz)),
  getCentersIncidentExcel: (start_date, end_date, id) =>
    dispatch(IncidentActions.CentersIncidentRequest(start_date, end_date, id)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Medallia))



// WEBPACK FOOTER //
// ./src/Containers/Reports/Medallia.jsx